import { fragment, type Fragment } from '@owl-nest/graphql'
import * as logger from '@owl-nest/logger'

export type Asset = {
  sys: { id: string }
  contentType: string
  description: string | null
  fileName: string
  height: number
  size: number
  title: string
  url: string
  width: number
}

const baseAssetFragment = fragment`
      fragment BaseAsset on Asset {
        contentType
        description
        fileName
        height
        size
        title
        width
        sys {
            id
        }
    }
`

export const ASSET_FRAGMENT = fragment`
    fragment StandardAsset on Asset {
        ...${baseAssetFragment}
        url
    }
`

export function responsiveImageFragment(sizes: number[], label?: string): Fragment {
  if (!sizes || sizes.length !== 3) {
    logger.err('[contentful] Attempt to get responsive image without setting sizes')
    return ASSET_FRAGMENT
  }

  return fragment`
      fragment ${label}ResponsiveImage on Asset {
          ...${baseAssetFragment}
          url(transform: { format: WEBP, quality: 100, width: ${sizes[0]}})
          url_2x: url(transform: { format: WEBP, quality: 100, width: ${sizes[1]}})
          url_3x: url(transform: { format: WEBP, quality: 100, width: ${sizes[2]}})
    }
  `
}

export type RichText<BLOCK_ENTRY = any> = {
  json: any
  links: {
    assets: {
      block: Asset[]
    }
    entries: {
      block: BLOCK_ENTRY[]
    }
  }
}

export type ResponsiveImage = Omit<Asset, 'url'> & SrcSet

export type SrcSet = {
  url: string
  url_2x: string
  url_3x: string
}
